import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ResetIcon } from '../../../../../utils/SVGIcon';
import { useAgencyInfo } from '../../../AgencyInfoProvider';
import { handleAddressResetOpe } from './AddressOperation';

// -- Address Reset Button
function AddressReset({ data }) {
    const { setMessage, setConfirm } = useTemplate();
    const { handleReload } = useAgencyInfo();
    const handleAddressResetConfirm = () => {
        const { userId, addressType } = data;
        handleAddressResetOpe(userId, addressType)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                handleReload();
                setConfirm(null);
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };
    const handleReset = () => {
        setConfirm({
            text: 'Are you sure you want to reset this address?',
            textAction: 'Reset',
            clickAction: () => {
                handleAddressResetConfirm();
            }
        });
    };

    return (
        <button
            type="button"
            onClick={handleReset}
            className="w-7 h-7 bg-error/10 hover:bg-error text-error hover:text-white/95  p-1 rounded-md transition-colors"
            aria-label="Loading..."
        >
            <ResetIcon />
        </button>
    );
}

export default AddressReset;
